export const trackPageView = (path: string) => {
  window._uxa = window._uxa || [];
  window._uxa.push(['trackPageview', path]);
};
